import store from "@/store";
import reportStoreModule from "../reportStoreModule";
import toast from "@/utils/toast";
import { onUnmounted, ref, watch } from "@vue/composition-api";
import moment from "moment";
import { inflate } from 'pako';
import { Base64 } from 'js-base64';

export default function useReportByServiceType() {

  const STORE_MODULE_NAME = 'report';

  // Register module
  if (!store.hasModule(STORE_MODULE_NAME)) {
    store.registerModule(STORE_MODULE_NAME, reportStoreModule);
  }

  // UnRegister on leave
  onUnmounted(() => {
    if (store.hasModule(STORE_MODULE_NAME)) {
      store.unregisterModule(STORE_MODULE_NAME);
    }
  });
  // Use toast
  const toastification = toast();
  const environment = process.env.VUE_APP_PROVIDER || "development";
  const reportType = ref({
    id: 1,
    name:
      environment === "vbill" || environment === "development"
        ? "Khoản thu theo nhóm khách hàng và loại dịch vụ"
        : "Khoản thu theo lớp và loại dịch vụ",
  });
  const school = ref(null)
  const classObject = ref(null)
  const grade = ref(null)
  const month = ref(moment().startOf('month').format("MM-YYYY"))
  const isLoading = ref(false)
  const htmlContent = ref(null)
  const startDate = ref(null)
  const endDate = ref(null)

  const fetchData = (isExport) => {
    isLoading.value = true
    let dispatchName = 'getReportByServiceType'
    if (reportType.value.id === 2) {
      dispatchName = 'getReportByService'
    } else if (reportType.value.id === 3) {
      dispatchName = 'getReportRevenueSummary'
    } else if (reportType.value.id === 4) {
      dispatchName = 'getReportByStudentAndService'
    }
    store.dispatch(`report/${dispatchName}`,
      {
        month: month.value,
        schoolId: school.value ? school.value.id : null,
        isExport,
        startDate: startDate?.value,
        endDate: endDate?.value,
        classId: classObject?.value ? classObject.value.id : null,
        grade: grade?.value,
      }
    ).then(response => {
      isLoading.value = false
      if (isExport) {
        window.location.href = response.data; //data is link if isExport
      } else {
        const compressed = Base64.toUint8Array(response.data);
        htmlContent.value = inflate(compressed, { to: 'string' });
      }

    }).catch(error => {
      toastification.showToastError(error)
      isLoading.value = false
    })
  }

  const exportData = () => {
    fetchData(true)
  }

  watch(month, newVal => {
    fetchData()
  })
  watch(school, newVal => {
    fetchData()
  })
  watch(reportType, newVal => {
    fetchData()
  })

  watch(startDate, newVal => {
    fetchData()
  })

  watch(endDate, newVal => {
    fetchData()
  })

  watch(grade, newVal => {
    fetchData()
  })

  watch(classObject, newVal => {
    fetchData()
  })

  return { school, classObject, grade, month, fetchData, htmlContent, reportType, exportData, startDate, endDate, isLoading }
}